import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import grey from '@mui/material/colors/grey'

const options = [
  'None',
  'Atria',
  'Callisto',
  'Dione',
  'Ganymede',
  'Hangouts Call',
  'Luna',
  'Oberon',
  'Phobos',
  'Pyxis',
  'Sedna',
  'Titania',
  'Triton',
  'Umbriel',
]

export interface Props {
  confirmText: React.ReactNode
  show: boolean
  setShow: (value: boolean) => void
  callback: () => void
}

export default function ConfirmationDialog(props: Props) {
  const handleNo = () => {
    props.setShow(false)
  }

  const handleYes = () => {
    props.setShow(false)
    props.callback()
  }

  return (
    <Dialog
      sx={{'& .MuiDialog-paper': {width: '80%', maxHeight: 435}}}
      maxWidth='xs'
      open={props.show}
    >
      <DialogTitle>Confirm Choice</DialogTitle>
      <DialogContent dividers>
        <Typography variant={'h6'} color={grey[600]}>
          {props.confirmText}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleNo} color={'inherit'} variant={'contained'}>
          No
        </Button>
        <Button onClick={handleYes} variant={'contained'}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}
